import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
  RSelect,
} from "../../components/Component";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactSelect from "react-select";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import { DEFAULT_INVENTORY_OUT_OUTSIDE, INVENTORY_FUEL_CATEGORY, TRUCK_TYPE } from "../../utils/Utils";

const MyInventoryOutOutside = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [truckOptions, setTruckOptions] = useState([]);
  const [pnCustomerOptions, setPNCustomerOptions] = useState([]);

  const [rangeDate, setRangeDate] = useState({
    startDate: searchParams.get('startDate') ? moment(searchParams.get('startDate')).startOf('days').toDate() : moment().startOf("months").toDate(),
    endDate: searchParams.get('endDate') ? moment(searchParams.get('endDate')).endOf('days').toDate() : moment().endOf('days').toDate(),
  });

  const [filter, setFilter] = useState({
    customerId: searchParams.get('customerId') || undefined,
  });

  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
    isAgree: false,
  });

  const {
    errors,
    register,
    handleSubmit,
    reset,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      ...DEFAULT_INVENTORY_OUT_OUTSIDE
    },
  });

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/self-employee/inventory-out-outside-transaction/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
          customerId: data?.pnCustomerMoneyFlow?.customerId,
          date: moment(data.date).format("YYYY-MM-DDTHH:mm"),
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  };

  const colTable = [
    {
      Header: "Biển số xe",
      accessor: (item) => item?.truckId || "",
    },
    {
      Header: "Số lượng dầu(l)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.quantity || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Đơn giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.unitPrice || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Giá(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.price || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tài xế",
      accessor: (item) => item?.user?.name || "",
    },
    {
      Header: "Nhà cung cấp",
      accessor: (item) => item?.customer?.name,
    },
    {
      Header: "Ngày tạo",
      accessor: (item) =>
        moment(item.date).format("DD/MM/YYYY HH:mm:ss") || "",
    },
    {
      Header: "Hành động",
      accessor: (item) => <ul className="nk-tb-actions gx-1">
        <li>
          <UncontrolledDropdown>
            <DropdownToggle
              tag="a"
              className="btn btn-icon dropdown-toggle btn-trigger"
            >
              <Icon name="more-h"></Icon>
            </DropdownToggle>
            <DropdownMenu right>
              <ul className="link-list-opt no-bdr">
                <li>
                  <DropdownItem
                    tag="a"
                    href="#dropdown"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onEditClick(item.id);
                      toggle("edit");
                    }}
                  >
                    <Icon name="edit"></Icon>
                    <span>Sửa</span>
                  </DropdownItem>
                </li>
                <li>
                  <DropdownItem
                    tag="a"
                    href="#dropdown"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setDeleteId(item.id);
                      toggle("isDelete");
                    }}
                  >
                    <Icon name="trash" className="text-danger"></Icon>
                    <span>Xoá</span>
                  </DropdownItem>
                </li>
              </ul>
            </DropdownMenu>
          </UncontrolledDropdown>
        </li>
      </ul>,
    },
  ];

  useEffect(() => {
    GET("truck", {
      type: TRUCK_TYPE.TRUCK
    }, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setTruckOptions(
          data.rows.map((c) => ({
            label: c.id,
            value: c.id,
            data: c,
          }))
        );
      }
    });

    GET(`/pn-customer`, {
    }, true)
      .then(({ data }) => {
        setPNCustomerOptions(data.map(c => ({
          label: c.name,
          value: c.id,
          data: c
        })))
      })
  }, []);

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      ...rangeDate,
      ...(filter.customerId ? { customerId: filter.customerId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    setData([]);
    let params = {
      startDate: moment(rangeDate.startDate).format("YYYY-MM-DD"),
      endDate: moment(rangeDate.endDate).format("YYYY-MM-DD"),
      ...(filter.customerId ? { customerId: filter.customerId } : {}),

    };

    GET(`/self-employee/inventory-out-outside-transaction`, params, true)
      .then(({ data: { rows, summary } }) => {
        setData(rows);
        setSummary(summary)
      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);

  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false, isScan: false, isAgree: false });
    reset({
      ...DEFAULT_INVENTORY_OUT_OUTSIDE
    });
    setEditedId();
    setDeleteId();
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const {
      date,
      customerId,
      quantity,
      truckId,
      price,
    } = getValues();

    const formData = {
      date,
      customerId: customerId || null,
      quantity,
      unitPrice: quantity > 0 ? Math.round(price / quantity) : 0,
      truckId,
      price,
    };

    const request = editId
      ? PUT(`/self-employee/inventory-out-outside-transaction/${editId}`, formData, {}, true)
      : POST("/self-employee/inventory-out-outside-transaction", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  const deleteInventoryOutOutside = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/self-employee/inventory-out-outside-transaction/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý tổng kho"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đổ dầu ngoài</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <DatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <ReactSelect
                          isClearable
                          placeholder="Tìm kiếm nhà cung cấp"
                          classNamePrefix="form-control"
                          options={pnCustomerOptions}
                          value={pnCustomerOptions.find(
                            (c) => c.value === filter.customerId
                          )}
                          onChange={(val) =>
                            setFilter({
                              ...filter,
                              customerId: (val && val.value) || "",
                            })
                          }
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li className="">
                      <div className="">
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            onFormCancel();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm đổ dầu ngoài</span>
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >

                <div className="my-3">
                  <h5 className="text-center mt-2 mb-2">Báo cáo đổ Báo cáo đổ {INVENTORY_FUEL_CATEGORY[filter.category]} ngoài</h5>
                  <h6 className="text-center mt-2 mb-2">Từ {moment(rangeDate.startDate).format('DD-MM-YYYY')} đến {moment(rangeDate.endDate).format('DD-MM-YYYY')} </h6>

                  <Table
                    loading={loading}
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                    headerRow={(
                      <tr className="nk-tb-item odd font-weight-bold">
                        <td colSpan={1} className="nk-tb-col">
                          <span> Tổng kết ({data?.length || 0} giao dịch) </span>
                        </td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary.quantity || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />

                        </td>
                        <td></td>
                        <td className="nk-tb-col text-right">
                          <NumericFormat
                            value={summary.total || 0}
                            displayType={'text'}
                            decimalScale={2}
                            thousandSeparator={','}
                            thousandsGroupStyle="thousand"
                          />

                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    )}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"}</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Ngày
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            className="form-control"
                            type="datetime-local"
                            name="date"
                            ref={register({ required: "Vui lòng nhập thông tin" })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="date"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>


                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" >
                          NCC
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="customerId"
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                isClearable
                                inputRef={ref}
                                name={name}
                                options={pnCustomerOptions}
                                value={pnCustomerOptions.find((c) => c.value === value)}
                                onChange={(val) => onChange(val?.value || null)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="customerId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Số lượng
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="quantity"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="weight"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Giá
                          <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="price"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                inputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={2}
                                onValueChange={(val) =>
                                  onChange(val.floatValue)
                                }
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="price"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label">
                          Bản số xe <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="truckId"
                            rules={{ required: "Vui lòng nhập thông tin" }}
                            render={({ onChange, value, name, ref }) => (
                              <RSelect
                                isClearable
                                placeholder="Biển số xe"
                                options={truckOptions}
                                value={truckOptions.find(
                                  (c) => c.value === value
                                )}
                                onChange={(val) => onChange(val.value)}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="truckId"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col size="12">
                      <Button color="primary" type="submit">
                        <span>{editId ? "Sửa" : "Thêm"}</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá giao dịch này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteInventoryOutOutside(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default MyInventoryOutOutside;
